import { useSavedChartsStore } from '@/stores/savedChartsStore';
import { useAuthentication } from '@/composables/useAuthentication';
import { useActionResultMessages } from '@/composables/useActionResultMessages';
import { useModals } from '@/composables/useModals';
import { updateDefaultChartStyle } from '@/composables/updateDefaultChartStyle';
import { refreshChartStyles } from '@/composables/refreshChartStyles';
import { refreshDefaultChartStyle } from '@/composables/refreshDefaultChartStyle';
import { SimpleFrontendChartStyle } from '@/interfaces/chartStyle';

export async function setDefaultChartStyle(chartStyle: SimpleFrontendChartStyle) {
  const savedChartsStore = useSavedChartsStore();
  const { isLoggedIn } = useAuthentication();
  const {
    addGreenActionResultMessage,
    addRedActionResultMessage
  } = useActionResultMessages();
  const { launchCreateAccountModal } = useModals();

  if (!isLoggedIn.value) {
    launchCreateAccountModal();
    return;
  }

  const recid = chartStyle.recid;

  savedChartsStore.$patch({ recidOfDefaultChartStyle: recid });

  try {
    await updateDefaultChartStyle(recid);

    addGreenActionResultMessage('Success! Your default ChartStyle has been saved!');
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Error occurred while updating default ChartStyle with recid: ${recid}.`, e);

    addRedActionResultMessage('Failed to set default ChartStyle.');
  }

  await Promise.all([
    refreshChartStyles(),
    refreshDefaultChartStyle()
  ]);
}
